import React from 'react';
import { FiTrash2, FiGlobe, FiMail, FiClock, FiEyeOff } from 'react-icons/fi';
import SettingsModal from '../clientSettings/SettingsModal';
import { useHubSite } from './shared';

interface Props {
    // "Article", "Person", "Document" — goes in the title and the button
    noun: string;
    name: string;
    onClose: () => void;
    onRemove: () => void;
    // offers "Hide Instead" (keeps it in Investi, off the website)
    onHide?: () => void;
}

// confirmation before removing a news item, person or document from the website (spec 409:12422)
const RemoveItemModal: React.FC<Props> = ({ noun, name, onClose, onRemove, onHide }) => {
    const { host } = useHubSite();
    const lower = noun.toLowerCase();
    return <SettingsModal danger icon={<FiTrash2 />} title={`Remove This ${noun} from the Website?`} sub={`“${name}”`} onClose={onClose}
        footer={<>
            {onHide && <button type="button" className="btn-outline with-icon" onClick={onHide}><FiEyeOff /> Hide Instead</button>}
            <button type="button" className="btn-danger" onClick={onRemove}><FiTrash2 /> Remove {noun}</button>
        </>}>
        <div className="hub-remove-list">
            <div><FiGlobe /> It disappears from {host} immediately.</div>
            <div><FiMail /> Anyone who clicks the link in an old email will see “This {lower} is no longer available”.</div>
            <div><FiClock /> You can restore it from the bin for 30 days.</div>
        </div>
    </SettingsModal>;
};

export default RemoveItemModal;
